import DomainInfo from './DomainInfo';
import axios from 'axios';
import { keysToCamel } from './KeysToCamel';

//this class is used once the user is logged in, so basically any component nested under /
//It makes sure the user is logged in and redirects them if not.

const handleError = function (error: any) {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 426) {
      window.location.href = '/login';
    } else if (error.response.data) {
      // The API returns errors as an OBJECT ({ success: false, message }), and
      // `new Error(someObject)` stringifies to the literal "[object Object]" —
      // so every server error in the app surfaced as that instead of the
      // message the backend went to the trouble of sending. Seen live on
      // /coaching/my-report, where a perfectly good 403 ("No active coach
      // report is available for this account") rendered as [object Object].
      const data: any = error.response.data;
      const message =
        typeof data === 'string'
          ? data
          : data?.message || data?.error || JSON.stringify(data);
      const err: any = new Error(message);
      // Keep the payload and status reachable so callers can branch on them
      // rather than string-matching the message.
      err.status = error.response.status;
      err.data = data;
      throw err;
    }
  } else {
    throw new Error(error);
  }
};

export async function getRequest(path: string, params?: object) {
  try {
    const response = await axios.get(`${DomainInfo.baseUrl}${path}`, {
      params: params,
      headers: { AuthToken: localStorage.getItem('CWAuthToken') }
    });
    return keysToCamel(response.data);
  } catch (error: any) {
    handleError(error);
  }
}

export async function postRequest(path: string, body?: object) {
  try {
    const response = await axios.post(`${DomainInfo.baseUrl}${path}`, body, {
      headers: { AuthToken: localStorage.getItem('CWAuthToken') }
    });
    return keysToCamel(response.data);
  } catch (error) {
    handleError(error);
  }
}

export async function patchRequest(path: string, body: object) {
  try {
    const response = await axios.patch(`${DomainInfo.baseUrl}${path}`, body, {
      headers: { AuthToken: localStorage.getItem('CWAuthToken') }
    });
    return keysToCamel(response.data);
  } catch (error) {
    handleError(error);
  }
}

export async function deleteRequest(path: string, params?: object) {
  try {
    const response = await axios.delete(DomainInfo.baseUrl + path, {
      data: params,
      headers: { AuthToken: localStorage.getItem('CWAuthToken') }
    });
    return keysToCamel(response.data);
  } catch (error) {
    handleError(error);
  }
}

export async function putRequest(path: string, body?: object) {
  try {
    const response = await axios.put(DomainInfo.baseUrl + path, body, {
      headers: { AuthToken: localStorage.getItem('CWAuthToken') }
    });
    return keysToCamel(response.data);
  } catch (error) {
    handleError(error);
  }
}
